module.exports = __webpack_public_path__ + "img/email-invite.647149da.svg";